
export const mutations = {
    STORE_USER_ROLE(state, userroles) {
        state.userroles = userroles
    },

    UPDATE_USER_ROLE(state, userroleId) {
        let newUserRole = state.userroles
        if (newUserRole.includes(parseInt(userroleId)) === true) {
            var index = newUserRole.indexOf(parseInt(userroleId))
            if (index !== -1) {
                newUserRole.splice(index, 1)
                state.userroles = newUserRole
            }
        } else {
            state.userroles.push(userroleId)
        }
    },

    STORE_USER_ROLE_MODULES(state, rolemodules) {
        state.rolemodules = rolemodules
        state.modulePermissions = []
    },


    STORE_MODULE_ID(state, moduleId) {
        state.moduleId = moduleId
    },

    UPDATE_USER_ROLE_MODULES(state, rmoduleid) {

        let newUserRoleModules = state.rolemodules
        if (newUserRoleModules.includes(parseInt(rmoduleid)) === true) {
            var index = newUserRoleModules.indexOf(parseInt(rmoduleid))
            if (index !== -1) {
                newUserRoleModules.splice(index, 1)
                state.rolemodules = newUserRoleModules
            }
        } else {
            state.rolemodules.push(rmoduleid)
        }
    },

    STORE_ROLE_MODULES_PERMISSIONS(state, modpermissions) {
        state.modulePermissions = modpermissions
    },

    UPDATE_ROLE_MODULES_PERMISSIONS(state, permId) {
  
        let newRoleModulesPermissions = state.modulePermissions
        if (newRoleModulesPermissions.includes(parseInt(permId)) === true) {
            var index = newRoleModulesPermissions.indexOf(parseInt(permId))
            if (index !== -1) {
                newRoleModulesPermissions.splice(index, 1)
                state.modulePermissions = newRoleModulesPermissions
            }
        } else {
            state.modulePermissions.push(permId)
        }
    }
}

export default mutations


// WEBPACK FOOTER //
// ./src/vuex/modules/userroles/mutations.js